import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { fromPromise } from 'rxjs/internal-compatibility';
import { Observable } from 'rxjs/internal/Observable';
import { NodesService } from '../../../+home/+my-libraries/+sites/document-library/shared/services/nodes.service';
import { API_URLS } from '../../../../environments/env-routes';
import { APIHelper } from '../../../../shared/services/api-helper/api-helper.service';

@Component({
  selector: 'app-file-explorer',
  templateUrl: './file-explorer.component.html',
  styleUrls: ['./file-explorer.component.scss']
})
export class FileExplorerComponent implements OnInit {
  @Input() actionName: string;
  @Input() onlyFolders = true;
  @Output() parentIdChange = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() updateAriane = new EventEmitter();
  @Output() validate = new EventEmitter();
  public entries: any[];
  public loading: boolean;
  public selectedNode: any;
  public siteDisplay: boolean;
  public parentsArray: Observable<any>;
  public error: string;


  constructor(private api: APIHelper, private nodeService: NodesService) {
  }

  private _parentId: string;

  @Input() set parentId(value: string) {
    this._parentId = value;
    this.changeContent(value);
  }

  ngOnInit() {
  }

  public goToSite(siteId) {
    const queries = 'include=path,properties,allowableOperations,permissions&relativePath=/documentLibrary';

    this.loading = true;
    this.api.requestApi({action: API_URLS.nodes.nodes.replace(':nodeId', siteId), queryArgs: queries})
      .then((res) => {
        this.parentId = res.id;
      });
  }

  public onValidate() {
    const selectedNodeId = (this.selectedNode) ? this.selectedNode.id : this._parentId;
    if (selectedNodeId) {
      this.validate.emit(selectedNodeId);
    } else {
  
    }
  }

  isSameDocumentLocation() {
    return false;
  }

  changeContent(id?: string) {
    this.parentsArray = fromPromise(this.nodeService.getNodeParentsArray(id));
    if (!id) {
      this.getSites();
      return;
    }
    this.loading = true;
    this.error = '';
    this.parentIdChange.emit(id);
    this.siteDisplay = false;

    this.nodeService.getChildren(id, {maxItems: 50, skipCount: 0}, null, true)
      .then((res) => {
        this.entries = res.entries;
        if (this.onlyFolders) {
          this.entries = this.entries.filter((elem) => {
            return elem.entry.isFolder;
          });
        }

      })
      .catch(e => {
      
        this.error = e.error.briefSummary;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  toggleSelectNode(data) {
    if (this.selectedNode && this.selectedNode.id === data.entry.id) {
      this.selectedNode = null;
    } else {
      this.selectedNode = data.entry;
    }
  }

  isNodeSelected(data) {
    return this.selectedNode && (this.selectedNode.id === data.entry.id);
  }

  private getSites() {
    this.loading = true;
    this.siteDisplay = true;
    this.selectedNode = null;
    this.error = '';

    this.nodeService.getSites()
      .then((res) => {
        this.updateAriane.emit([]);
        this.entries = res.list.entries;
      })
      .catch(e => {
     
        this.error = e.error.briefSummary;
      })
      .finally(() => this.loading = false);
  }

  public backToRoot() {
    this.changeContent();
  }

  public changeParentId(newId) {
    this.parentId = newId;
  }
}
